<div nz-row nzGutter="16" >
  <div class="col-lg-7">
    <div class="d-md-flex">
      <div *ngIf="parentFolderIdResource" class="m-b-10 m-r-20">
        <button title="Go Back" (click)="goBack()" nz-button nzType="default" >
          <i nz-icon nzType="arrow-left" nzTheme="outline"></i>
        </button>
      </div>
      <div class="m-b-10 m-r-20">
        <!-- (keyup)="onKeyUp(searchBox.value)" -->
        <nz-input-group [nzPrefix]="prefixTemplate" [nzSuffix]="suffixTemplate">
          <input type="text" nz-input [(ngModel)]="searchTerm" placeholder="Search" 
          #searchBox
           />
        </nz-input-group>
        <ng-template #suffixTemplate>
          <a nz-icon class="opacity-05" (click)="resetSearch()">
            <i nz-icon nzType="close" class="opacity-05"></i>
          </a>
        </ng-template>

        <ng-template #prefixTemplate>
          <i nz-icon nzType="search" class="opacity-05"></i>
        </ng-template>
      </div>
      <div class="m-b-10 m-r-10">
        <!-- [nzDisabled]="isLoading || !searchBox.value" -->
        <button class="btn-fill" nz-button nzType="default" nzSize="small" (click)="applySearch(searchBox.value)"
          
          >
          Search
        </button>
      </div>
    </div>
  </div>

  <div class="col-lg-5">
    <div class="d-md-flex justify-content-end">
      <!-- m-r-20 -->
      <div class="m-b-10">
        <button
              nz-button
              nz-popover
              [nzPopoverContent]="content"
              nz-popover
              nzPopoverTrigger="click"
              nzPopoverPlacement="bottom"
              [(nzPopoverVisible)]="filterVisible"
              (nzPopoverVisibleChange)="onPopoverVisibleChange($event)"
              class="btn-outline resource-btn"
              style="text-align: center"
            >
              All Resources<i
                nz-icon
                nzType="caret-down"
                style="position: relative; top: 1px; left: -3px"
                nzTheme="outline"
              ></i>
            </button>
            <ng-template
              class="filter"
              style="text-align: left; padding: 0px !important"
              #content
            >
              <div class="">
                <div nz-row nzGutter="24">
                  <div
                    nz-col
                    class="gutter-row"
                    nzSpan="24"
                    style="padding-bottom: 15px"
                  >
                    <span class="filter-heading">Category</span>
                  </div>
                </div>
              </div>
              <div style="height: 120px" nz-row>
                <div
                  style="color: #2d2d35; font-family: Poppins !important"
                  nz-col
                  nzSpan="24"
                >
                  <label nz-checkbox [(ngModel)]="residential"
                    >Residential</label
                  >
                  <nz-divider
                    style="
                      margin-top: 5px !important;
                      margin-bottom: 10px !important;
                    "
                  ></nz-divider>
                  <label nz-checkbox [(ngModel)]="commercial">Commercial</label>
                  <nz-divider
                    style="
                      margin-top: 5px !important;
                      margin-bottom: 10px !important;
                    "
                  ></nz-divider>
                  <label nz-checkbox [(ngModel)]="competition">Competition</label>
                </div>
              </div>
              <div nz-row>
                <div
                  nz-col
                  nzSpan="24"
                  class="d-flex align-items-center justify-content-between"
                >
                  <span class="cancel-label" (click)="cancelFilter()"
                    >Cancel</span
                  >
                  <button
                    class="btn-fill"
                    nz-button
                    nzType="default"
                    nzSize="small"
                    (click)="applyFilters()"
                  >
                    Apply
                  </button>
                </div>
              </div>
            </ng-template>
      </div>
      <!-- <div class="m-b-10 m-r-10">
        <nz-select
          class="ellipsis-select"
          nzPlaceHolder="Please select"
          nzSize="small"
          style="width: 100%"
          nzMode="multiple"
          [(ngModel)]="selectedCategories"
          (ngModelChange)="changeCategory()"
        >
          <nz-option
            *ngFor="let org of resourceCategoryFilterList"
            [nzValue]="org.value"
            [nzLabel]="org.text"
          >
          </nz-option>
        </nz-select>
      </div> -->

      <!-- nzPopoverTitle="New Resource" -->
      <!-- <button
        nz-button
        nzType="default"
        nz-popover
        nzPopoverPlacement="bottomRight"
        nzPopoverTrigger="click"
        class="btn-fill"
      >
        <span>
          <i class="fa fa-plus button-plus-icon" aria-hidden="true"></i></span
        >&nbsp;NEW
      </button> -->
    </div>
  </div>
</div>

<div class="row" [@wipeOutRight]>
  <div nz-col>
    <div>
      <nz-spin [nzSpinning]="isLoading" nzTip="Loading...">
        <div
        #scrollContainer
        class="table-wrapper" infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="150"
          (scrolled)="onScrollDown($event)" scrollWindow="true" (scroll)="onScroll($event)" style="height: 400px; overflow: auto">
    <!-- [nzData]="filteredResourcess" -->
          <nz-table
        #resourcesListTable
        
        class="no-border-last"
        [nzScroll]="{ x: '100%' }"
        [nzShowPagination]="false"
        [nzFrontPagination]="false"
        (nzQueryParams)="onSortChange($event)"
            
      >
        <thead>
          <tr>
            <th nzWidth="40px">
              <label
                nz-checkbox
                [(nzChecked)]="allChecked"
                (nzCheckedChange)="checkAll($event)"
                [nzIndeterminate]="indeterminate"

              ></label>
            </th>
            <ng-container *ngFor="let column of listOfColumns">
              <!-- [nzSortFn]="column.sortFn" -->
              <!-- [nzFilterMultiple]="column.filterMultiple" -->
              <th
                *ngIf="column.name !== ''"
                [nzSortOrder]="column.sortOrder"
                [nzSortDirections]="column.sortDirections"
                [nzColumnKey]="column.key"
                [nzWidth]="column.colWidth"
                [nzSortFn]="column.Showsort"
                [nzShowSort]="column.Showsort"
              >
                {{ column.name }}
              </th>
            </ng-container>
            <!-- <th nzShowSort nzSortKey="name">Name</th>
            <th nzShowSort nzSortKey="size">Size</th>
            <th nzShowSort nzSortKey="popularity">Popularity</th>
            <th nzShowSort nzSortKey="assignment">Assignment</th>
            <th nzShowSort nzSortKey="uploaded">Uploaded</th>
            <th nzShowSort nzSortKey="expires">Category</th>
            <th nzShowSort nzSortKey="tags" nzFilterMultiple="true">Tag</th>

            <th></th>
            <th></th> -->
          </tr>
        </thead>
        <tbody>
          <ng-template ngFor let-item [ngForOf]="filteredResourcess">
            <tr
              style="cursor: pointer"
              [hidden]="!item.is_active"
              (dblclick)="displayFiles(item)"
              (click)="displayFolder(item)"
           
            >
              <ng-container>
                <td>
                  <label
                    class="m-r-4 "
                    nz-checkbox
                    [(nzChecked)]="item.checked"
                    (nzCheckedChange)="onCheckboxChange(item)"
                    [nzIndeterminate]="item.mixedState"
                    style="width: 50px;"
                  ></label>
                </td>
                <td class="disabled" style="text-align: center; width: 100px;">
                  {{item.index}}
                </td>
                <td>
                  <!-- COMMENT -->
                  <div class="d-flex align-items-center">
                    <div
                      class=""
                      style="cursor: pointer"
                      [ngClass]="{ active: selectedFile == item.name }"
                      (contextmenu)="
                        contextMenu($event, contextDropdownTpl, item.name)
                      "
                      [ngClass]="{ active: selectedFile == item.name }"
                    >
                      <div class="font-size-20" style="line-height: 0; display: flex; justify-content: center; align-items: center; width: 40px; height: 40px;">
                        <i
                          *ngIf="item.is_folder === 1"
                          [twoToneColor]="colorGold"
                          nz-icon
                          nzType="folder-open"
                          theme="twotone"
                        ></i>
                        
                      <!-- PDF -->
                      <ng-container *ngIf="item.is_folder === 0">
                        <nz-avatar 
                          *ngIf="item.resource_thumbnail && item.resource_path && getFileIcon(item.resource_path) === 'file-pdf'"
                          [nzShape]="'square'"                              
                          [nzSrc]="thumbnailBaseURL + item.resource_thumbnail">
                        </nz-avatar>
                        <i
                          *ngIf="!item.resource_thumbnail && item.resource_path && getFileIcon(item.resource_path) === 'file-pdf'"
                          [twoToneColor]="colorRed"
                          nz-icon
                          nzType="file-pdf"
                          theme="twotone"
                        ></i>
                        <!-- <i
                          *ngIf="
                            getFileIcon(item.resource_path) ===
                            'file-word'
                          "
                          [twoToneColor]="colorBlue"
                          nz-icon
                          nzType="file-word"
                          theme="twotone"
                        ></i> -->
                        <!-- <i
                          *ngIf="
                            getFileIcon(item.resource_path) ===
                            'file-excel'
                          "
                          [twoToneColor]="colorCyan"
                          nz-icon
                          nzType="file-excel"
                          theme="twotone"
                        ></i> -->

                        <!-- Image -->
                        <nz-avatar 
                        *ngIf="item.resource_path && getFileIcon(item.resource_path) === 'file-image'"
                        [nzShape]="'square'"
                          
                        [nzSrc]="thumbnailBaseURL + item.resource_path">
                        
                        </nz-avatar>
                        <!-- 
                        *ngIf=" && (item.resource_path && getFileIcon(item.resource_path) === 'file-image')"
                      >
                      <nz-avatar nzIcon="user" nzSrc={{item.resource_url}} nzSize="small"></nz-avatar>
                    </> -->
                        <!-- For link  -->
                        <span style="width: 40px;
                          height: 40px;
                          display: flex;
                          align-items: center;
                          justify-content: center;" *ngIf="item.resource_url != null && (item.size == null || item.size === '')
                            " nz-icon nzType="link" nzTheme="outline">
                          </span> 

                    <!-- For video  -->

                        <i
                          *ngIf="!item.resource_thumbnail && 
                          item.resource_path && getFileIcon(item.resource_path) ===
                            'file'
                          "
                          [twoToneColor]="colorCyan"
                          nz-icon
                          nzType="play-circle"
                          theme="twotone" 
                        ></i>
                        <nz-avatar 
                        *ngIf="item.resource_thumbnail && item.resource_path && getFileIcon(item.resource_path) === 'file'"
                        [nzShape]="'square'"
                          
                        [nzSrc]="thumbnailBaseURL + item.resource_thumbnail">
                        
                        </nz-avatar>
                        
                      </ng-container>
                      </div>
                    </div>

                    <span class=" m-l-10 m-b-0 long-text " style="display:flex; flex-direction: column; justify-content: center;height: 100%; ">{{ item.resource_name }} 
                    <p *ngIf="item.size" style="color:#98A4AE; font-size: 13px;">File size:  {{ item.size }}</p>
                    <!-- <p *ngIf="!item.size" style="color:#98A4AE;  font-size: 13px;">File size:  N/A</p> -->
                    </span>

                  </div>
                </td>
                 <!-- Categories -->
                 <td>
                  <span *ngIf="!item.category_name">-</span>
                  {{ item.category_name }}
                  </td>

                   <!-- upload -->
                  <td>{{ item.uploaded_date | date: 'MM/dd/yyyy'}}</td>

                <!-- Popularity -->
                <!-- <td>
                  <nz-badge
                    *ngIf="item.popularity == 'high'"
                    nzStatus="success"
                  ></nz-badge>
                  <nz-badge
                    *ngIf="item.popularity == 'Medium'"
                    nzStatus="error"
                  ></nz-badge>
                  <nz-badge
                    *ngIf="item.status == 'Not enough data'"
                    nzStatus="processing"
                  ></nz-badge>
                  <span *ngIf="!item.popularity" class="text-capitalize">
                    <nz-badge nzStatus="success">high</nz-badge></span
                  >
                </td> -->
                
                <!-- <td>
                  <div class="d-flex align-items-center">
                    <div>
                      <nz-avatar
                        [nzSize]="30"
                        nzIcon="user"
                        [nzSrc]="item.avatar"
                      ></nz-avatar>
                    </div>

                    <span class="m-l-10 m-b-0">{{ item.group_names }}</span>
                  </div>
                </td> -->
              
               <!-- Shareable -->
                  <td>
                    <!-- <span class="data-row-action"> -->
                    <span class="">
                      <nz-switch [(ngModel)]="item.is_shareable" [nzControl]="true" 
                         nzSize="small" [nzDisabled]="true"></nz-switch>
                    </span>
                  </td>


                <!-- Tags -->
                  <!-- <td>
                  <ng-container *ngIf="item.tag && item.tag.length > 0">
                    <ng-container
                      *ngIf="item.tag.length <= 2; else moreTags"
                    >
                      <nz-tag
                        *ngFor="let tag of item.tag.slice(0, 2)"
                        [nzMode]="default"
                        [nzColor]="'#ededed'"
                      >
                        {{ tag.tag_name }}
                      </nz-tag>
                    </ng-container>
                    <ng-template #moreTags>
                      <span *ngFor="let tag of item.tag.slice(0, 2)">
                        <nz-tag [nzMode]="default" [nzColor]="'#ededed'">{{
                          tag.tag_name
                        }}</nz-tag>
                      </span>

                      <span
                        nz-popover
                        [nzPopoverContent]="moreContents"
                        nzPopoverPlacement="bottom"
                        (mouseenter)="updateMoreTagsContent(item.tag)"
                        (mouseleave)="resetMoreTagsContent()"
                      >
                        <nz-tag [nzMode]="default" [nzColor]="'#ededed'"
                          >+{{ item.tag.length - 2 }} more</nz-tag
                        >
                      </span>

                      <ng-template #moreContents>
                        <span *ngFor="let tag of moreTagsContent">
                          <nz-tag
                            [nzMode]="default"
                            [nzColor]="'#ededed'"
                            >{{ tag }}</nz-tag
                          >
                        </span>
                      </ng-template>
                    </ng-template>
                  </ng-container>
                </td> -->
                <!-- assignment -->
                <td>
                  <div class="d-flex align-items-center">
                    <div *ngIf="item.group_names.length > 0">
                      <nz-avatar
                        [nzSize]="30"
                        nzIcon="user"
                        [nzSrc]="item.avatar"
                      ></nz-avatar>
                    </div>
                    <span *ngIf="item.group_names.length <= 0">-</span>
                    <span class="m-l-10 m-b-0">
                      <ng-container
                        *ngIf="
                          item.group_names.length <= 2;
                          else moreGroups
                        "
                      >
                        {{ item.group_names.join(", ") }}
                      </ng-container>

                      <ng-template #moreGroups>
                        {{ item.group_names.slice(0, 2).join(", ") }},
                        <span
                          nz-popover
                          [nzPopoverContent]="moreContent"
                          nzPopoverTrigger="hover"
                          nzPopoverPlacement="bottom"
                        >
                          {{ item.group_names.length - 2 }} more
                        </span>

                        <ng-template #moreContent>
                          {{ item.group_names.slice(2).join(", ") }}
                        </ng-template>
                      </ng-template>
                    </span>
                  </div>
                </td>
                

                <!-- <td>
                  <nz-tag
                    *ngFor="let tag of item.tag; let i = index"
                    [nzMode]="default"
                    [nzColor]="'#ededed'"
                  >
                    {{ tag.tag_name }}
                  </nz-tag>
                </td> -->
              </ng-container>
            </tr>
          </ng-template>
        </tbody>
      </nz-table>
        </div>
      </nz-spin>
    </div>
  </div>
</div>
